var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1719_6195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.69238,
    width: 47.9236,
    height: 47.3462,
    rx: 11.4331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1719_6195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5549 30.9133H18.7156C18.4019 30.9133 18.1477 31.1775 18.1477 31.5034V39.4098C18.1477 39.7357 18.4019 39.9999 18.7156 39.9999H21.5549C21.8685 39.9999 22.1228 39.7357 22.1228 39.4098V31.5034C22.1228 31.1775 21.8685 30.9133 21.5549 30.9133Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8458 23.7842H24.0065C23.6928 23.7842 23.4386 24.0484 23.4386 24.3743V39.4146C23.4386 39.7405 23.6928 40.0047 24.0065 40.0047H26.8458C27.1594 40.0047 27.4137 39.7405 27.4137 39.4146V24.3743C27.4137 24.0484 27.1594 23.7842 26.8458 23.7842Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1367 27.0803H29.2974C28.9837 27.0803 28.7295 27.3445 28.7295 27.6704V39.41C28.7295 39.7359 28.9837 40.0001 29.2974 40.0001H32.1367C32.4503 40.0001 32.7046 39.7359 32.7046 39.41V27.6704C32.7046 27.3445 32.4503 27.0803 32.1367 27.0803Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4321 21.0161H34.5928C34.2791 21.0161 34.0249 21.2803 34.0249 21.6062V39.4147C34.0249 39.7406 34.2791 40.0048 34.5928 40.0048H37.4321C37.7457 40.0048 38 39.7406 38 39.4147V21.6062C38 21.2803 37.7457 21.0161 37.4321 21.0161Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0002 15L34.0851 16.0746L35.0362 17.0677L30.6133 21.6254L25.3409 18.4446L18.2218 25.1804C17.9448 25.4443 17.9263 25.8856 18.1756 26.1735C18.3095 26.327 18.4942 26.4038 18.6743 26.4038C18.8358 26.4038 19.002 26.3414 19.1313 26.2215L25.5164 20.1813L30.8303 23.3861L35.9873 18.0704L36.9383 19.0635L38.0002 15Z",
    fill: "#AB54A2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1719_6195",
    x: 0.57006,
    y: 0.262443,
    width: 59.3567,
    height: 58.7793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28663,
    dy: 2.28663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.403922 0 0 0 0 0.517647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1719_6195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1719_6195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1719_6195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 25,
    fill: "white",
    transform: "translate(18 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphsIcon);
export default __webpack_public_path__ + "static/media/graphs-icon.e347010bfc50746992bde3841330e37c.svg";
export { ForwardRef as ReactComponent };